export enum SystemLineUsageEnum{
  None = 0,
  SystemVerification = 1,
  Notification = 2,
  Advertising = 4,
  Module = 8,
  Cooperation = 16,
  InternalOperations = 32,
  PublicLineGroup = 64,
  PayamakSefid = 128
}


export enum PrebuyLineStatus {
  Rejected = 1,
  Expired = 2,
  Accepted = 3,
  Paid = 4,
  ReservedByOthers = 5,
  PendingLineInquiry = 6,
  PendingDocumentUpload = 7,
  DocumentReviewByAdmin = 8,
  ReUploadDocuments = 9,
  DocumentsSentToOperatorByAdmin = 10,
  ReadyForPayment = 11,
  AwaitingAdminFinalApproval = 12,
  AwaitingOriginalDocuments = 13,
  PaymentWindowExpired = 14,
}

export enum PrebuyFileStatus {
  UploadedByUser = 1,
  UseExistingFile = 2,
  ModifiedByUser = 3,
  RejectedByAdmin = 4,
  RejectedByOperator = 5,
  Accepted = 6,
  Expired = 7,
}

export enum PrebuyLineFileType {
  //  [Description("جواز کسب")]
  TradeLicense = 1,
  //  [Description("شناسنامه")]
  IdentityCertificate = 2,
  //  [Description("تصویر روی کارت ملی")]
  NationalIDCardFront = 3,
  //  [Description("تصویر پشت کارت ملی")]
  NationalIDCardBack = 4,
  //  [Description("فرم تعهدنامه")]
  CommitmentAgreement = 5,
  //  [Description("سفته")]
  CollateralNote = 6,
  //  [Description("فرم تعهدنامه در سربرگ")]
  OfficialCommitmentLetter = 7,
  //  [Description("روزنامه رسمی")]
  OfficialRegistrationGazette = 8,
  //  [Description("آگهی تأسیس")]
  IncorporationNotice = 9,
  //  [Description("آخرین تغییرات")]
  LatestAmendments = 10,
  //  [Description("جواز صنفی")]
  BusinessPermit = 11,
  //  [Description("قبض تلفن")]
  TelephoneBill = 12,
  //  [Description("نوع فعالیت")]
  ActivityType = 13,
  //  [Description("نمونه متن")]
  SampleText = 14,
  //  [Description("جامعه هدف")]
  TargetAudience = 15,
  //  [Description("معرفی نامه")]
  LetterOfIntroduction = 16,

}



export enum LineStatus{
  Pending = 1,
  Deactivated = 2,
  Activated = 3
}


export enum ServiceLineStatus{
  Created = 1,
  RejectedByAdmin = 2,
  AcceptedByAdmin = 3,
  RejectedByProvider = 4,
  ModifiedByUser = 5,
  AcceptedByProvider = 6,
  Finished = 7,
}


export enum ServiceLineFileType {
  Commitment = 1,
  Numbers = 2,
  Promissory = 3,
  NationalCard = 4,
}


export enum ServiceLineFileStatus {
  NotProvided = 1,
  Provided = 2,
  RejectedByAdmin = 3,
  AcceptedByAdmin = 4,
  RejectedByProvider = 5,
  ModifiedByUser = 6,
  AcceptedByProvider = 7
}
